import Equipment from "../js/components/configuration/equipment/Equipment.react";
export default Equipment;
